<template>
  <div class="mw-split-container">
    <mw-dialog size="mini_mini" ref="unitDialog" title="选择单位" :footerButton="unitFooterButton" :close-on-click-modal="false">
      <mw-tree :url="unitTreeUrl" :defaultParams="defaultUnitParams" :async="false"  ref="unitTree" :multiple="true" :contextMenuItem="contextMenuItem"
               :expandedFirst="true"
               :checkNodes="checkUnitIds"></mw-tree>
    </mw-dialog>
    <mw-dialog ref="impDialog" title="导入权限定义数据" @opened="showUpload" size="mini_small" :footerButton="impBtton">
      <div class="mw-dialog_body " style="margin-top:20px;">
        <el-form label-width="100px">
          <el-col :span="24">
            <el-form-item label="导入说明:">
              <template>
                第一步：单击此处<el-button @click="downloadExcel" >下载模版</el-button><br/>
                第二步：按照模板格式录入数据;<br/>
                第三步：上传模板文件:
              </template>
            </el-form-item>
            <el-form-item label="上传文件:">
              <el-button ref="uploader">上传文件</el-button>
              <div class="el-upload__tip">只能上传.xls文件</div>
              <!--<template>-->
                <!--<el-upload ref="importData"-->
                           <!--:on-success="importSuccessCallback"-->
                           <!--style="display: inline-block;"-->
                           <!--:auto-upload="false"-->
                           <!--:action="importAction"-->
                           <!--multiple-->
                           <!--:headers="headers"-->
                           <!--:limit="1">-->
                  <!--<el-button >获取文件</el-button>-->
                  <!--<div slot="tip" style="" class="el-upload__tip">只能上传.xls/.xlsx文件</div>-->
                <!--</el-upload>-->
              <!--</template>-->
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </mw-dialog>
    <split-pane :defaultSize="418">
      <template slot="paneL">
        <div class="mw-split-left">
          <div class="mw-toolbar">
            <el-button @click="addRole()"><i class="fa fa-plus-square" type="primary" v-if="!btnNotShowIcon"></i>新增</el-button>
            <el-button @click="deleteRole()"><i class="fa fa-trash-o" type="primary" v-if="!btnNotShowIcon"></i>删除</el-button>
            <el-button @click="expand"  v-show="expandFlag==1"><i class="fa fa-angle-double-down" v-if="!btnNotShowIcon"></i>展开</el-button>
            <el-button @click="closed"  v-show="expandFlag!=1"><i class="fa fa-angle-double-up" v-if="!btnNotShowIcon"></i>折叠</el-button>
            <el-dropdown trigger="hover" @command="handleMoreCommand">
              <el-button class="el-dropdown-link">
                更多<i class="el-icon-caret-bottom el-icon--right"></i>
              </el-button>
              <el-dropdown-menu class="mw-toolbar-dropdown" slot="dropdown">
                <el-dropdown-item command="import" >导入</el-dropdown-item>
                <el-dropdown-item command="export">导出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="mw-toolbar__body">
            <mw-tree :url="roleTreeUrl" :defaultParams="defaultTreeParams" :async="true" :contextMenuItem="contextMenuItem" :dragEnable="true"
              :expandedFirst="true" :selectFirst="true" ref="roleTree" @changed="changed"></mw-tree>
          </div>
        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right">
          <div class="mw-toolbar">
            <el-button @click="saveRole"  type="primary" size="mini"><i class="fa fa-file-text-o" v-if="!btnNotShowIcon"></i> 保存</el-button>
            <span style="float:right;width: 100%;">
              <el-button type="info" @click="helpnotes" style="float:right;">
                <i class="fa fa-question" v-if="!btnNotShowIcon"></i>帮助
              </el-button>
              <span v-if="form.id" class="pull-right">
              <b>权限编码：</b>{{form.id}}
              </span>
            </span>
          </div>
          <div class="mw-toolbar__body">
            <el-form label-width="130px" class="mw-form" :rules="rules" :model="form" ref="roleForm">
              <el-col :span="24">
                <el-form-item prop="id" v-show="false">
                  <el-input v-model="form.id"></el-input>
                </el-form-item>
                <el-form-item label="权限名称" prop="name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
              </el-col>

              <!-- <el-col :span="24">
                <el-form-item label="权限类别" prop="code">
                  <el-input v-model="form.code"></el-input>
                </el-form-item>
              </el-col> -->

              <el-col :span="24">
                <el-form-item label="权限类型" prop="type">
                  <template>
                    <el-radio-group v-model="form.type">
                      <el-radio label="1">身份权限</el-radio>
                      <el-radio label="2">文档权限</el-radio>
                      <el-radio label="3">流程权限</el-radio>
                    </el-radio-group>
                    </template>

                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="所属单位" prop="unitNames">
                  <el-input type="textarea" v-model="form.unitNames" :rows="2" readonly>
                  </el-input>
                  <el-button @click="showUnitDialog"  :class="selIconCls||''">{{!selIconCls ? '选择' : ' '}}</el-button>
                </el-form-item>
                <el-form-item prop="unitIds" v-show="false">
                  <el-input v-model="form.unitIds"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="权限描述" prop="dec">
                  <el-input v-model="form.dec"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </div>
      </template>
    </split-pane>
  </div>

</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    data() {
      let me = this;
      return {
        unitDialogVisible: false,
        selIconCls:(window.$Env && $Env.selIconCls),
        btnNotShowIcon:(window.$Env && $Env.btnNotShowIcon),
        edit: false,
        expandFlag:1,
        change: false,
        reset: false,
        defaultTreeParams:{t:Date.now()},
        defaultUnitParams:{},
        unitTreeUrl: this.mwUrl('/api/org/getUnitTreeContainSelf'),
        roleTreeUrl: this.mwUrl('/api/org/listAllGroupedRole'),

        contextMenuItem: [{name: 'add', icon: 'fa fa-plus-square', label: '新增', func: me.addRole}, {
          name: 'delete',
          label: '删除',
          icon: 'fa fa-trash-o',
          func: me.deleteRole
        }],

        unitFooterButton: [
          {label: '全选', func: me.selectAllUnit},
          {label: '不选', func: me.unSelectAllUnit,type:'default'},
          {label: '确定', func: me.selectUnitSure},
          {label: '取消', func: me.selectUnitCancel,type: 'default'}
        ],
        checkUnitIds: [],
        form: {
          id: '',
          name: '',
          dec: '',
          code: '',//类别
          unitNames: '',
          unitIds: '',
          authType: '1',
          type:'1'
        },

        form1: {},
        rules: {
          name: [
            {required: true, message: '请输入名称', trigger: 'blur'}],
          code: [
            {required: true, message: '请输入类别', trigger: 'blur'}]
        },
        importAction:'/api/org/importRoleFromExcel',
        impBtton:[ {
          label: "取消",
          func:this.impCancel,
          type: "default"
        }],
        headers: {},
        isFirstOpen:true
      }
    },
    computed: {
    ...mapGetters([
        'userInfo',
        'expUser'
      ]),
    },
    mounted(){
      //this.defaultTreeParams.t = Date.now() ;
       let isSysAdmin = this.isSysAdmin();
       let parentId;
      if(this.userInfo.developer || isSysAdmin){
        parentId== this.userInfo.owner;
      }else{
        if(this.$store.getters.curUnit && this.$store.getters.curUnit.length > 0){
          parentId = this.$store.getters.curUnit[0].id;
        }
      }
      if(parentId)this.defaultUnitParams.parentId=parentId;
    },
    methods: {
      showUpload(){
         if(this.isFirstOpen){
           this.initUploader();
           this.isFirstOpen=false;
         }
      },
      initUploader(){
          let me=this;
          let cfg={
            buttonId:me.mwRef('uploader').$el,
            maxSize:500,
            action:me.importAction,
            accept:"xls"
          }
          let fn={
            fileUploaded(up, file,resp){debugger
               me.importSuccessCallback(resp,file,up);
             }
          }
          PF.initPupload(cfg,fn);
      },
      //树选择
      changed(data) {
        let me = this;
        if(this.change){
          this.$confirm('文档修改后尚未保存，是否保存?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          me.saveRole();
        }).catch(() => {me.refresh();});
          me.change =  false;
        }else{
        if (data.id && data.hasChild == 0) {
          me.resetFields();
          me.mwApi.org.getRole(data.id).then(res => {
            if(res.result){
              for(let i in res.result){
                me.form1[i] = res.result[i]
              }
              me.form1.authType = res.result.authType ? res.result.authType : '1'
              me.mwUtil.applyCover(me.form, res.result);
              this.edit =   true;
              this.reset = false;
              }
          })
        }}
      },
      helpnotes(){
        PF.showHelp({url:'/helpDoc/platform/permission.md'})
      },
      isSysAdmin(){
        if(this.userInfo.roleNames && this.userInfo.roleNames.indexOf("系统管理员") !=-1){
          return true;
        }
        return false;
      },
      addRole(data, parents) {
        this.resetFields();
        this.edit =  false;
        if(this.mwRef('roleTree').getSelected()){
          if(!data){
            let node =  this.mwRef('roleTree').getSelected();
            let parents = this.mwRef('roleTree').getNode(node.id).parents;
            let nodeName = [];
            parents.forEach( p =>{
              if(p != '#')
              nodeName.push(this.mwRef('roleTree').getNode(p).text);
            });
            this.form.code =nodeName.join('/');
          }else{
            if (parents) {
              let code = [];
              if (data.hasChild != 0) {
                code.push(data.name);
              }
              parents.forEach(d => {
                code.unshift(d.name);
              });
              this.form.code = code.join("/");
            }
          }
          var treeNode = this.mwRef('roleTree').getSelected();
          if(["身份权限","文档权限","流程权限"].indexOf(treeNode.name)>-1){
            if(treeNode.name=="身份权限"){
              this.form.type="1"
            }else if(treeNode.name=="文档权限"){
              this.form.type="2"
            }else if(treeNode.name=="流程权限"){
              this.form.type="3"
            }
          }else{
            this.form.type = treeNode.type;
          }

        }
      },
      saveRole() {
        let me = this;
        me.mwRef('roleForm').validate((valid => {
          if (valid) {
            me.mwApi.org.saveRole(me.form).then(data => {
              if (data.success) {
                me.mwMsg('权限保存成功');
                me.refresh();
              }
              else {
                me.mwMsg('warning','权限保存失败');
              }
              this.change = false;
            });
          } else {
            me.mwMsg('warning','请输入完整信息');
          }
        }));
      },
      deleteRole(data) {
        let me = this;
        if(!data){
          if(this.mwRef('roleTree').getSelected()){
            data = this.mwRef('roleTree').getSelected();
          }else{
            me.mwMsg('请选择要删除的节点!');
          }
        }
        if (data.hasChild == 0) {
          me.mwConfirm('您确定要删除此权限').then(() => {
            me.mwApi.org.deleteRole(data.id).then(res => {
              if (res.success) {
                me.mwMsg("删除成功");
                this.edit =  false;
                this.change = false;
                me.refresh();
              } else {
                me.mwMsg('warning','删除失败');
              }
            })
          }).catch(() => {

          });
        } else {
          me.mwConfirm('您确定要删除此类别权限').then(() => {
            me.mwApi.org.deleteRoleByCate(data.id).then(res => {
              if (res.success) {
                me.mwMsg("删除成功");
                this.change = false;
                me.refresh()
              } else {
                me.mwMsg("删除失败");
              }
            })
          }).catch(() => {

          });
        }
      },

      showUnitDialog() {
        let me = this;
        if (me.form.unitIds) {
          me.checkUnitIds = me.form.unitIds.split(',');
        } else {
          me.checkUnitIds = [];
        }
        me.mwRef('unitDialog').show();
      },

      selectAllUnit() {
        this.mwRef('unitTree').checkAll();
      },

      unSelectAllUnit() {
        this.mwRef('unitTree').unCheckAll();
      },

      selectUnitSure() {
        let me = this, unitIds = [], unitNames = [];
        this.mwRef('unitTree').getSelected().forEach(d => {
          unitIds.push(d.id);
          unitNames.push(d.text);
        });
        me.form.unitIds = unitIds.join();
        me.form.unitNames = unitNames.join();
        this.selectUnitCancel();
      },
      selectUnitCancel() {
        this.mwRef('unitDialog').hide();
      },

      resetFields() {
        this.reset = true;
        this.mwRef('roleForm').resetFields();
      },
      refresh() {
        //this.defaultTreeParams.t = Date.now() ;
        this.resetFields();
        this.mwRef('roleTree').refresh();
      },
      expand() {
        this.expandFlag = 2;
        this.mwRef('roleTree').openAll();
      },
      closed() {
        this.expandFlag = 1;
        this.mwRef('roleTree').closeAll();
      },
      handleMoreCommand(command){
        let me=this;
        if(command === 'import'){
          this.mwRef('impDialog').show();
        }
        if(command === 'export'){
          me.mwUtil.downloadAttachment(this.mwUrl("/api/org/exportRoleToExcel"),{},false,"");
        }
      },
      impCancel(){
        this.mwRef('impDialog').hide();
      },
      importSuccessCallback(response,file,up) {
        if(response.result){
          this.mwRef('roleTree').refresh();
          PF.show('message',{html:response.result.errMsg});
          this.mwRef('impDialog').hide();
        }
        this.mwRef("importData").clearFiles();
      },
      downloadExcel(){
        var me = this;
        me.mwUtil.downloadAttachment("/template_file/importRoleExcel.xls");
      }
    },
    watch:{
      form:{
        handler(curVal,oldVal){
          var me = this;
         if(!this.reset){
          this.change = false;
          for(let i in curVal){

            if(curVal[i]){
              if(i === 'type'){
                  if(curVal["id"]&&curVal["id"]!=""&& (curVal[i] != this.form1[i])){
                    me.mwConfirm('修改后将会影响该权限之前配置的角色作用').then(() => {
                      me.change = true;
                    }).catch(() => {
                      curVal[i] = this.form1[i]
                    });
                  }
              }else if( i === 'authType'){
                if((curVal[i] != this.form1[i])){
                  this.change = true;
                }
              }else{
              if(!this.form1[i]){
                this.form1[i] = ''
              }
              if((curVal[i] != this.form1[i])){
                this.change = true;
              }}
          }}}
　　　　},
　　　　 deep:true
      }
    }
  }
</script>

<style scoped>
  .el-input, .el-textarea {
    width: 60%;
  }

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/role.vue